export default {
  siteName: 'AirAgri',
  siteIcon: 'ion-flash',
  footerText: `Airagri @ ${new Date().getFullYear()} Created by AirAgri Services Pty Ltd`,
  enableAnimatedRoute: false,
  apiUrl: 'http://yoursite.com/api/',
  google: {
    analyticsKey: 'UA-xxxxxxxxx-1',
  },
  dashboard: '/dashboard',
};
